export const categories = [
  {
    id: "livelihood",
    name: "民生关注",
    icon: "ri-home-heart-line",
    count: 128,
    desc: "社区治理、公共设施、居民生活难题",
  },
  {
    id: "consumer",
    name: "消费维权",
    icon: "ri-shopping-bag-3-line",
    count: 96,
    desc: "虚假宣传、售后纠纷、价格陷阱",
  },
  {
    id: "workplace",
    name: "职场内幕",
    icon: "ri-briefcase-4-line",
    count: 74,
    desc: "用工违规、薪酬黑幕、职场乱象",
  },
  {
    id: "industry",
    name: "行业黑幕",
    icon: "ri-building-2-line",
    count: 88,
    desc: "行业潜规则、违规操作、灰色链条",
  },
  {
    id: "environment",
    name: "环境安全",
    icon: "ri-leaf-line",
    count: 53,
    desc: "污染排放、安全隐患、生态破坏",
  },
  {
    id: "finance",
    name: "财经线索",
    icon: "ri-line-chart-line",
    count: 61,
    desc: "资金异常、理财陷阱、财务疑点",
  },
  {
    id: "online",
    name: "网络乱象",
    icon: "ri-global-line",
    count: 112,
    desc: "网络诈骗、虚假流量、平台乱象",
  },
  {
    id: "education",
    name: "教育观察",
    icon: "ri-book-open-line",
    count: 47,
    desc: "办学问题、收费争议、招生乱象",
  },
];